<template>
  <div v-if="props.video" class="h-full relative overflow-hidden">
    <div
      v-if="!props.isActive"
      class="relative z-0"
      :class="props.video.isPortrait === '1' ? 'aspect-9/16' : 'aspect-video'"
      @click="emit('activateVideo')"
    >
      <Button
        severity="help"
        icon="pi pi-play"
        rounded
        class="absolute left-2 bottom-2 bg-white z-10"
        aria-label="Play Video"
      />

      <img
        :src="thumbnail.url"
        :width="thumbnail.width"
        :height="thumbnail.height"
        class="absolute h-full"
        :class="
          props.video.isPortrait === '1'
            ? 'min-w-[200%] -left-1/2!'
            : 'w-full object-cover inset-0'
        "
        alt=""
      />
    </div>

    <ScriptYouTubePlayer
      v-else-if="videoId"
      trigger="immediate"
      :video-id="videoId"
      :player-vars="playerVars"
      class="h-full relative overflow-hidden"
      :class="props.video.isPortrait === '1' ? 'aspect-9/16!' : 'aspect-video'"
    />
  </div>
</template>

<script setup lang="ts">
import type { Video } from '~/types';
import extractVideoId from '~/utils/extractVideoId';

const props = defineProps<{
  video: Video | undefined;
  isActive?: boolean;
  isPortrait: '0';
  uuid?: string;
}>();

const emit = defineEmits<{
  activateVideo: [];
}>();

const videoId = computed(() => extractVideoId(props.video?.video?.videoUri));
const playerVars = { controls: 1, playsinline: 1, rel: 0, autoplay: 1 };

const thumbnail = computed(() => {
  const videoId = extractVideoId(props.video?.video?.videoUri);
  return videoId
    ? {
        url: `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`,
        width: 480,
        height: 360,
      }
    : {
        url: '',
        width: 0,
        height: 0,
      };
});
</script>
